<template>
  <v-dialog v-model="dialog" fullscreen scrollable lazy hide-overlay>
    <v-card>
      <v-toolbar color="primary" dark tabs>
        <v-toolbar-title>{{ selected.name }}</v-toolbar-title>
        <v-spacer />
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
        <v-tabs
          slot="extension"
          v-model="tab"
          color="primary"
          slider-color="white"
          centered
        >
          <v-tab>{{ $tc('models.entity') }}</v-tab>
          <v-tab :disabled="!selected._id">
            {{ $tc('models.team', 2) }}
          </v-tab>
          <v-tab :disabled="!selected._id">
            {{ $tc('models.user', 2) }}
          </v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item ripple>
            <tab-view />
          </v-tab-item>
          <v-tab-item ripple>
            <v-layout row wrap>
              <v-flex xs12>
                <tab-teams :entity-id="selected._id" entity-view />
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item ripple>
            <entity-users v-if="selected._id" :entity-id="selected._id" />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TabTeams from '../teams/Dashboard'
import TabView from './TabView'
import EntityUsers from './entity-users/EntityUsers'

export default {
  name: 'EntityView',
  components: {
    TabView,
    TabTeams,
    EntityUsers,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
    tab(val) {
      this.$nextTick((_) => {
        if (val === 2) this.fetchUsers({ entity: this.selected._id, limit: 0 })
      })
    },
  },
  computed: {
    ...mapState({
      selected: (state) => state.entities.selected,
    }),
  },
  methods: {
    ...mapActions({
      reset: 'entities/reset',
      resetTeamState: 'teams/resetState',
      fetchUsers: 'users/fetchList',
    }),
    cancel() {
      this.tab = 0
      this.reset()
      this.resetTeamState()
      this.$emit('close')
    },
  },
}
</script>
